export default __webpack_public_path__ + "static/NotoSans-SemiBold-99df72e26c72877cb1f90631bc1acfc6.ttf";